import { API_SERVER } from 'config/constant';
import { getMethod, postMethod, urls } from 'utils/url/urls';

export async function gettranslateddata(data) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.translate}`,
      postMethod(data),
    );
    const result = await response.json();
    return result;
  } catch (err) {
    console.log('gettranslateddata Error:', err);
  }
}

export async function storeChat(data) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.storeChat}`,
      postMethod(data),
    );
    const result = await response.json();
    return result;
  } catch (err) {
    console.log('gettranslateddata Error:', err);
  }
}

export async function getChats(gaId) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.getChats}${gaId}`,
      getMethod,
    );
    const result = await response.json();
    return result;
  } catch (err) {
    console.log('gettranslateddata Error:', err);
  }
}
